<template>
    <b-card v-if="isLoaded" style="border:none;">
        <div style="margin-bottom:10px">
            <b-row align-h="between" style="background-color: white">
                <b-col class="float-left mt-1" cols="3" sm="3" style="font-weight: bold; text-align: center; font-size: 1.2em;">
                    <div style="position: relative; width: 70px;">
                        <span class="float-left" style="font-size: 1.4em">{{ $t('sitesTitle') }}</span>
                        <span style="font-size: 0.8em; color: #868e96; position: absolute; margin: 10px 2px">({{filteredItems.length}})</span>
                    </div>
                </b-col>
                <b-col cols="9" sm="9" md="9" lg="9" xl="9">
                    <b-row align-h="end" no-gutters>
                        <site-type-select v-if="siteTypes.length" style="margin-right: 20px" @onchange="onSiteTypeChange"/>
                        <region-multi-select
                            :selectedRegionId="selectedRegionId"
                            :regions="regions"
                            @oninput="selectedRegionId = ($event) ? ($event).id : null"
                        />
                        <div style="width: 130px" class="placeholder-color-white">
                            <b-form-input v-model="searchInput" :placeholder="$t('siteSearchPlaceholder')" type="text" class="gray-input" style="margin-left: 10px"/>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
        </div>
        <div class="container-card scroll-content" style="height:740px;">
            <table class="table table-hover mt-2" style="table-layout: fixed; font-size: 0.875em;border-collapse: separate;border-spacing:0;">
                <thead style="position: sticky;background-color: white;top: 0px;z-index:2">
                    <tr>
                        <th style="width: 10em;">{{ $t('tableSiteName') }}</th>
                        <th style="width: 10em;">{{ $t('lastUpdatedAt') }}</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="filteredItem in filteredItems">
                    <td @click="routeTo(filteredItem)" style="cursor: pointer;">{{filteredItem.name}}</td>
                    <td v-if="filteredItem.lastUpdatedAt">{{ filteredItem.lastUpdatedAt | formatDate('DD/MM/YYYY') }}</td>
                    <td v-else>-</td>
                </tr>
                </tbody>
            </table>
        </div>
    </b-card>
    <div v-else></div>
</template>

<script>
import YearSelect from '../../components/YearSelect';
import SiteTypeSelect from '../../components/SiteTypeSelect';
import RegionMultiSelect from '../../components/RegionMultiSelect';
export default {
    name: 'site-selector',
    components: {RegionMultiSelect, SiteTypeSelect, YearSelect},
    data() {
        return {
            searchInput: '',
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null,
            isLoaded: false
        };
    },
    methods: {
        onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
        },
        routeTo(site) {
            /* this.$router.push({
                name: 'site-data-types',
                params: {site_id: site.id},
                query: {
                    year: this.year
                }
            }); */
            let routeData = this.$router.resolve({
                name: 'site-data-types',
                params: {site_id: site.id},
                query: {
                    year: this.year
                }
            });
            if (this.gbId(this.$store.state.user.customerId)) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'site-data-types',
                    params: {site_id: site.id},
                    query: {
                        year: this.year
                    }
                });
            }
        },
        retrieveSites() {
            this.$Progress.start();
            this.isLoaded = false;
            return this.axios.get('/sites').then(({data}) => {
                this.$store.commit('SET_SITES', data.sites);
                this.$Progress.finish();
                this.isLoaded = true;
            });
        }
    },

    computed: {
        filteredItems() {
            return this.sites.filter(item => {
                return (
                    this.isSearchTextFound(item.name, this.searchInput) &&
                    this.isRegionFound(this.selectedRegionId, item.siteGroupId) &&
                    (!this.selectedTypeId || item.typeId === this.selectedTypeId)
                );
            });
        }
    },

    created() {
        this.retrieveSites();
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        this.regions = [{id: null, display_name: this.$t('allRegions')}, ...this.siteGroups];
    }
};
</script>

<style lang="scss" scoped>
.nav-color {
    background-color: #eff3f6;
}
.nav-tabs .nav-link {
    border-left: none;
    border-top: none;
}
.table-sites {
    width: 75%;
    margin: auto;
    float: none;
}

</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "sitesTitle": "Lokasyonlar",
            "tableSiteName": "Lokasyon Adı",
            "tableDataHealth": "Veri Sağlığı"
        },
        "en": {
            "sitesTitle": "Sites",
            "tableSiteName": "Site",
            "tableDataHealth": "Data Health"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Data/SiteSelector.vue